// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// ** UseJWT import to get config
import config from "../@core/auth/jwt/jwtDefaultConfig";
import { getUserData } from "@src/utility/Utils";

interface UserData {
  accessToken?: string;
  refreshToken?: string;
  [key: string]: unknown;
}

interface AuthState {
  userData: UserData;
  [key: string]: unknown;
}


export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: getUserData(),
  } as AuthState,
  reducers: {
    handleLogin: (state, action: PayloadAction<UserData>) => {
      console.log("🟢 Login reducer called with payload:", action.payload);
      state.userData = action.payload;
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName];
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      localStorage.setItem("userData", JSON.stringify(action.payload));
      localStorage.setItem(
        config.storageTokenKeyName,
        JSON.stringify(action.payload.accessToken)
      );
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        JSON.stringify(action.payload.refreshToken)
      );
    },
    handleLogout: (state) => {
      console.log("🔴 LOGOUT REDUCER CALLED - Starting logout process");
      console.log("🔴 Current state before logout:", state.userData);
      
      // Clear Redux state
      state.userData = {};
      state[config.storageTokenKeyName] = null;
      state[config.storageRefreshTokenKeyName] = null;
      
      // Remove items from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem(config.storageTokenKeyName);
      localStorage.removeItem(config.storageRefreshTokenKeyName);
      
      console.log("🔴 LOGOUT COMPLETED - State cleared");
      
      // Force page reload to ensure complete logout
      // setTimeout(() => {
      //   console.log("🔄 Redirecting to login page");
      //   window.location.href = "/login";
      // }, 100);
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;